import { auctionWonRuleQuery$data } from '../__generated__/auctionWonRuleQuery.graphql';

type ActivityFeed =
    | NonNullable<auctionWonRuleQuery$data['viewer']['user']>['activityFeed']
    | undefined
    | null;
type GetItemType<T extends ActivityFeed> = NonNullable<
    NonNullable<
        NonNullable<NonNullable<NonNullable<NonNullable<T>['edges']>[number]>['node']>['anchors']
    >[number]
>['source'];

export const getValidItems = <T extends ActivityFeed>(activityFeed: T): GetItemType<T>[] =>
    (activityFeed?.edges
        ?.filter(edge => Date.now() < new Date(edge?.node?.expirationDate || 0).getTime())
        .flatMap(edge => edge?.node?.anchors)
        .filter(
            anchor =>
                anchor?.sourceType === 'ITEM' &&
                anchor.source?.lastTransaction?.isAuctionWonAndPending
        )
        .map(anchor => anchor?.source) || []) as GetItemType<T>[];
